//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stage1 from '~/components/boarding/Stage1'
import Stage2 from '~/components/boarding/Stage2'
import Stage3 from '~/components/boarding/Stage3'
import Stage4 from '~/components/boarding/Stage4'
import MtArrowLink from '~/components/other/MtArrowLink'
import { Portal } from 'portal-vue'
import { loadGsap } from '@/utils/utils'

export default {
  components: {
    MtArrowLink,
    Stage1,
    Stage2,
    Stage3,
    Stage4,
    Portal
  },
  data () {
    const texts = [
      this.$t('onboarding.slide1'),
      this.$t('onboarding.slide2'),
      this.$t('onboarding.slide3'),
      this.$t('onboarding.slide4'),
    ]

    return {
      stage: 0,
      timer: null,
      texts: texts,
      gsapReady: !!window.gsap
    }
  },
  computed: {
    stagedTexts: function () {
      return this.texts[this.stage]
    }
  },
  mounted () {
    loadGsap().then(() => {
      this.gsapReady = true
    })
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    nextStage () {
      let next = this.stage + 1

      if (next > 3) {
        next = 0
      }

      this.stage = next
    },
    waitNextStage () {
      this.timer = setTimeout(() => {
        if (this.stage !== 3) {
          this.nextStage()
        } else {
          this.dismiss()
        }
      }, 4000)
    },
    nextClick () {
      clearTimeout(this.timer)
      if (this.stage !== 3) {
        this.nextStage()
      } else {
        this.dismiss()
      }
    },
    dismiss () {
      this.$emit('dismiss')
    }
  }
}
